import { useAppSelector } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import Button from 'flow/components/ui-components/Button';
import Loading from 'flow/components/ui-components/Loading';
import RouteLink from 'flow/components/ui-components/RouteLink';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { Blocklist } from 'flow/types/Callrouting';
import { BlockistParams } from 'flow/types/Params';
import { routes } from 'flow/types/routes';

import { TypedMap } from 'flow/types/TypedMap';
import { generatePath } from 'flow/utils/router-utils';
import Page from '../Page';

const CallRoutingTypes = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const { openModal } = useModal();
    const { extensionKey, type } = useParams<BlockistParams>();

    const callRouting = useAppSelector((state) => state.callRoutings.get(type));

    if (!callRouting) {
        return <Loading />;
    }

    const blockLists = {
        blocked_in: 'settings.callrouting.incoming',
        blocked_out: 'settings.callrouting.outgoing',
        priority: 'settings.callrouting.priority',
    };

    const callRoutingHeaders = {
        blocked_in: 'settings.callrouting.add.redirect',
        blocked_out: 'settings.callrouting.add.block',
        priority: 'settings.callrouting.add.priority',
    };

    const emptyText = {
        blocked_in: 'settings.callrouting.blocked_routing.none',
        blocked_out: 'settings.callrouting.blocked.none',
        priority: 'settings.callrouting.priority.none',
    };

    const editableCallRoutings = callRouting.filter(
        (blockList: TypedMap<Blocklist>) => blockList.get('editByUser'),
    );

    return (
        <Page
            header={blockLists[type] || ''}
            onClickBack={() =>
                history.push(
                    generatePath(
                        routes['settings.softphone.advanced.callrouting'],
                        { extensionKey },
                    ),
                )
            }
        >
            <div className="mb-2 flex">
                <Button
                    color="primary"
                    onClick={() => {
                        openModal('createCallRouting', {
                            extensionKey,
                            type,
                        });
                    }}
                    iconKey="add"
                    className="py-1"
                >
                    {i18next.t(callRoutingHeaders[type])}
                </Button>
            </div>

            {editableCallRoutings.isEmpty() ? (
                <div className="py-6 text-center text-gray-400">
                    {i18next.t(emptyText[type])}
                </div>
            ) : null}
            {editableCallRoutings
                .valueSeq()
                .map((blockList: TypedMap<Blocklist>) => (
                    <RouteLink
                        key={blockList.get('key')}
                        to={generatePath(
                            routes[
                                'settings.softphone.advanced.callrouting.type.blocklistKey'
                            ],
                            {
                                extensionKey,
                                type,
                                blocklistKey: blockList.get('key'),
                            },
                        )}
                    >
                        {blockList.get('matcher') ||
                            blockList.getIn([
                                'blocklistPredefDTO',
                                'description',
                            ])}
                    </RouteLink>
                ))}
        </Page>
    );
};

export default CallRoutingTypes;
